import { useLocation } from "react-router-dom";
import Route from "../enums/route";
import { getAuthentication } from "../services/authentication/authenticationHelpers";
import { useCallback } from "react";
import { GoogleAuthenticationService } from "../services/authentication/googleAuthenticationService";
const useSafeLocation = () => {
    try {
        return useLocation();
    }
    catch {
        return null;
    }
};
const useRoutePrefix = () => {
    const location = useSafeLocation();
    const authenticationService = getAuthentication();
    const getByRoute = useCallback(() => {
        if (location === null || location === void 0 ? void 0 : location.pathname.startsWith(Route.VeoliaPrefix)) {
            return Route.VeoliaPrefix;
        }
        return Route.Home;
    }, [location]);
    const getByAuthentication = useCallback(() => {
        if (authenticationService instanceof GoogleAuthenticationService) {
            return authenticationService.authorizationProvider;
        }
        return Route.Home;
    }, [authenticationService]);
    return {
        getByRoute,
        getByAuthentication
    };
};
export default useRoutePrefix;
